import {
  Box,
  Heading,
  Text,
  SimpleGrid,
  Image,
  Link,
  VStack,
} from "@chakra-ui/react";

export default function BrandShowcase() {
  const brands = [
    {
      img: "/kohler.webp", // product image
      logo: "/kohler.png", // logo image
      desc: "Pull-down kitchen sink faucet with two-function sprayhead and soap dispenser",
      link: "#",
    },
    {
      img: "/hafele.webp",
      logo: "/hafele.png",
      desc: "Stay informed with the latest news, key brand milestones, and exciting event highlights from Häfele.",
      link: "#",
    },
    {
      img: "/duro.webp",
      logo: "/duro.png",
      desc: "All Duro products are made from handpicked high-grade raw materials",
      link: "#",
    },
  ];

  return (
    <Box
      bg="white"
      py={16}
      px={{ base: 4, md: 12 }}
      textAlign="center"
      maxW="1200px"
      mx="auto"
    >
      {/* Section Heading */}
      <Heading as="h2" size="xl" mb={4} fontWeight="bold">
        Inspiring your vision
      </Heading>
      <Text fontSize="md" maxW="700px" mx="auto" color="gray.600" mb={12}>
        Driven by innovation, creativity, and passion, we craft solutions that
        reflect the individuality of those we design for. Your vision inspires
        us—it’s both our motivation and our commitment to bring it to life with
        precision and purpose
      </Text>

      {/* Brand Cards */}
      <SimpleGrid columns={{ base: 1, md: 3 }} spacing={10}>
        {brands.map((brand, index) => (
          <VStack key={index} spacing={4} align="center">
            {/* Product / Lifestyle Image */}
            <Image
              src={brand.img}
              alt="Product showcase"
              borderRadius="7px"
              w="373px"
              h="240px"
              objectFit="cover"
              boxShadow="sm"
            />

            {/* Brand Logo */}
            <Image
              src={brand.logo}
              alt="Brand logo"
              h="40px"
              objectFit="contain"
              mt={2}
            />

            {/* Description */}
            <Text fontSize="sm" color="gray.600" textAlign="center" px={4}>
              {brand.desc}
            </Text>

            {/* Learn more link */}
            <Link
              href={brand.link}
              fontSize="sm"
              fontWeight="semibold"
              color="black"
              textDecoration="none"
              _hover={{ textDecoration: "underline" }}
            >
              Learn more
            </Link>
          </VStack>
        ))}
      </SimpleGrid>
    </Box>
  );
}
